import { toByteArray } from 'base64-js';
import { decode as msgpackDecode } from 'msgpack-lite';
function parse(encoded) {
    const data = toByteArray(encoded);
    return msgpackDecode(data);
}
export default parse;
